var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGearbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8134 10.3809H9.88245V12.3119H10.6548C11.0812 12.3119 11.4272 12.6579 11.4272 13.0843V16.9462C11.4272 17.3726 11.0812 17.7186 10.6548 17.7186H6.7929C6.36654 17.7186 6.02051 17.3726 6.02051 16.9462V13.0843C6.02051 12.6579 6.36654 12.3119 6.7929 12.3119H7.56529V10.3809H2.54477C1.69167 10.3809 1 11.0726 1 11.9257V18.1048C1 18.9579 1.69167 19.6496 2.54477 19.6496H11.8134C12.6665 19.6496 13.3582 18.9579 13.3582 18.1048V11.9257C13.3582 11.0726 12.6665 10.3809 11.8134 10.3809Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11005 15.7876H8.33767C7.91131 15.7876 7.56528 15.4416 7.56528 15.0152V12.3119H6.79289C6.36654 12.3119 6.02051 12.6579 6.02051 13.0843V16.9462C6.02051 17.3726 6.36654 17.7186 6.79289 17.7186H10.6548C11.0812 17.7186 11.4272 17.3726 11.4272 16.9462V13.0843C11.4272 12.6579 11.0812 12.3119 10.6548 12.3119H9.88244V15.0152C9.88244 15.4416 9.53641 15.7876 9.11005 15.7876Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8134 4.20185C11.8134 5.90805 10.43 7.2914 8.72382 7.2914C7.01762 7.2914 5.63428 5.90805 5.63428 4.20185C5.63428 2.49565 7.01762 1.1123 8.72382 1.1123C10.43 1.1123 11.8134 2.49565 11.8134 4.20185Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56531 7.06476V15.0153C7.56531 15.4417 7.91134 15.7877 8.33769 15.7877H9.11008C9.53644 15.7877 9.88247 15.4417 9.88247 15.0153V7.06476C9.52447 7.20997 9.13402 7.29145 8.72389 7.29145C8.31375 7.29145 7.92331 7.20997 7.56531 7.06476Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93091 12.702H4.08949V12.6942H2.93091V12.702Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93091 14.2468H4.08949V14.239H2.93091V14.2468Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93091 15.7915H4.08949V15.7838H2.93091V15.7915Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93091 17.3363H4.08949V17.3286H2.93091V17.3363Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGearbox);
export default __webpack_public_path__ + "static/media/icon-gearbox.2ae94651.svg";
export { ForwardRef as ReactComponent };